import API from "@unisearch/helpers/api";
import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import ForumContainer from "./component/forum_container";
import OtherPost from "./component/other_post/other_post";
import ForumWelcome from "./component/welcome/forum_welcome";
import styles from "./forum_main.module.scss";

export const ForumMain = ({
  groupList,
  popularGroup,
  groupTopic,
  recentPost,
  postList,
}) => {
  const [postData, setPostData] = useState(postList?.results);
  const [hasMore, setHasMore] = useState(true);

  const [page, setPage] = useState(2);

  const getMoreData = async () => {
    setPage(page + 1);
    const postAPI = `/public/forum-post/all-post-paginate-list`;
    const payload = {
      filter: {},
      sortOrder: "DESC",
      sortField: "forumPostId",
      pageNumber: page,
      pageSize: 1,
    };
    let getMorePostData = await API.post(postAPI, payload);
    if (!getMorePostData.error && getMorePostData.data.results.length > 0) {
      setPostData((data) => [...data, ...getMorePostData.data.results]);
    } else {
      setHasMore(false);
    }
  };


  return (
    <ForumContainer
      navigationFalse
      groupList={groupList}
      popularGroup={popularGroup}
      groupTopic={groupTopic}
      recentPost={recentPost}
    >
      <div className={styles.posts_wrapper}>
        <ForumWelcome />
        {/*<MyPost />*/}

        {postData?.length > 0 && (
          <InfiniteScroll
            dataLength={postData?.length}
            next={getMoreData}
            hasMore={hasMore}
            loader={<small> Loading...</small>}
            // endMessage={<h4 className="text-center">Nothing more to show</h4>}
          >
            <div className={styles.other_posts_wrapper}>
              {postData &&
                postData?.length > 0 &&
                postData.map((item, i) => (
                  <OtherPost
                    key={i}
                    profileImage={item?.profileImage}
                    name={item?.userName}
                    userType={item?.userType}
                    publishedDate={item?.publishedDate}
                    questionTitle={item?.questionTitle}
                    question={item?.question}
                    featureImage={item?.featureImage?.src}
                    video={item?.embeddedCode}
                    questionLink={item?.questionLink}
                    groupSlug={item?.groups?.slug}
                    commentType={"post"}
                  />
                ))}
            </div>
          </InfiniteScroll>
        )}
      </div>
    </ForumContainer>
  );
};

export default ForumMain;
